module.exports = __webpack_public_path__ + "static/media/visa.d5b0de69.png";